import { dataGet } from "./dot"

/**
 * Checks if 2 arrays are equal
 * 
 * @param {Array} array1 
 * @param {Array} array2 
 * @returns {Boolean}
 */
export const equal = (array1, array2) => {
    if(!Array.isArray(array1) || !Array.isArray(array2)){
        return false
    }

    return array1.length === array2.length
        && array1.every((value, index) => value === array2[index])
}

/**
 * Removes non-unique items from an array
 * 
 * @param {Array} array 
 * @param {String} field 
 * @returns {Array}
 */
export const unique = (array, field) => {
    if(!Array.isArray(array)){
        return false
    }

    return Object.values(
        Object.fromEntries(
            array.reduce(
                (final, item) => {
                    const value = dataGet(field, item)

                    if(!final.has(value)){
                        final.set(value, item)
                    }

                    return final
                }, 
                new Map
            )
        )
    )
}

/**
 * Makes sure an item is an array
 * 
 * @param {*} value 
 * @returns {Array}
 */
export const wrap = (value) => Array.isArray(value)
    ? value
    : [value]